import React from "react";
import { ResponsiveContainer, AreaChart, XAxis, YAxis, Tooltip, Area } from "recharts";

const AudioGraph = ({ data, dataKey, audioDuration }) => {
  // Process data to ensure valid values
  const processedData = data.map((item) => {
    const name = parseFloat(item.name); // Extract numeric part from "0s", "5s", etc.
    const value = item[dataKey];
    return {
      ...item,
      name: isNaN(name) ? 0 : name, // Fallback to 0 if name is invalid
      [dataKey]: isNaN(value) ? 0 : Math.max(value, 0), // Fallback to 0 if value is invalid
    };
  });

  // console.log("Processed Data:", processedData);

  // Custom Tooltip Renderer
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white shadow-lg rounded-md px-4 py-2 border border-blue-300">
          <p className="text-sm font-semibold text-gray-700">{label}s</p>
          <p className="text-base font-medium text-blue-500">
            {dataKey}: {payload[0].value.toFixed(2)}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="mt-10" style={{ width: "100%", height: "200px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={processedData}>
          {/* Define gradient */}
          <defs>
            <linearGradient id="gradient1" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#3A5AFE" stopOpacity={1} />
              <stop offset="70%" stopColor="#7A8BFD" stopOpacity={0.6} />
              <stop offset="100%" stopColor="#E3E7FF" stopOpacity={1} />
            </linearGradient>
          </defs>

          {/* XAxis with audioDuration as domain */}
          <XAxis
            dataKey="name"
            type="number"
            domain={[0, audioDuration]} // Set domain based on the audio duration
            tickFormatter={(tick) => `${tick}s`} // Format ticks as "0s", "5s", etc.
            tick={{ fill: "#4A5FC1" }}
            interval={(audioDuration / 5) < 10 ? 0 : "preserveStartEnd"} // Adjust interval dynamically
            ticks={Array.from({ length: Math.floor(audioDuration / 5) + 1 }, (_, i) => i * 5)} // Generate ticks at every 5s
          />
          <YAxis axisLine={false} tickLine={false} tick={{ fill: "#4A5FC1" }} />
          <Tooltip content={<CustomTooltip />} />

          {/* Apply gradient to the Area */}
          <Area
            type="monotone"
            dataKey={dataKey}
            stroke="#3A5AFE"
            strokeWidth={2}
            fill="url(#gradient1)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AudioGraph;